<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'dashboard/composables/store';
import { useAlert } from 'dashboard/composables';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  inbox: {
    type: Object,
    required: true,
  },
});

const { t } = useI18n();
const store = useStore();

const dialogRef = ref(null);
const isRotating = ref(false);

const rotate = async () => {
  isRotating.value = true;
  try {
    await store.dispatch('inboxes/rotateHmacToken', props.inbox.id);
    dialogRef.value.close();
    useAlert(t('INBOX_MGMT.SETTINGS_POPUP.HMAC_ROTATE.SUCCESS'));
  } catch (error) {
    useAlert(t('INBOX_MGMT.SETTINGS_POPUP.HMAC_ROTATE.ERROR'));
  } finally {
    isRotating.value = false;
  }
};
</script>

<template>
  <div class="flex flex-col gap-2">
    <woot-code :key="inbox.hmac_token" :script="inbox.hmac_token" />
    <div>
      <NextButton
        slate
        outline
        sm
        type="button"
        icon="i-lucide-key-round"
        :label="$t('INBOX_MGMT.SETTINGS_POPUP.HMAC_ROTATE.BUTTON')"
        @click="dialogRef.open()"
      />
    </div>
    <Dialog
      ref="dialogRef"
      type="alert"
      :title="$t('INBOX_MGMT.SETTINGS_POPUP.HMAC_ROTATE.TITLE')"
      :confirm-button-label="
        $t('INBOX_MGMT.SETTINGS_POPUP.HMAC_ROTATE.CONFIRM')
      "
      :cancel-button-label="$t('INBOX_MGMT.SETTINGS_POPUP.HMAC_ROTATE.CANCEL')"
      :is-loading="isRotating"
      @confirm="rotate"
    >
      <template #description>
        <div class="flex flex-col gap-2 text-sm text-n-slate-11">
          <p class="mb-0">
            <span class="font-medium text-n-slate-12">
              {{ $t('INBOX_MGMT.SETTINGS_POPUP.HMAC_ROTATE.WARNING') }}
            </span>
            {{ $t('INBOX_MGMT.SETTINGS_POPUP.HMAC_ROTATE.WARNING_DETAIL') }}
          </p>
          <p class="mb-0">
            {{ $t('INBOX_MGMT.SETTINGS_POPUP.HMAC_ROTATE.IMPACT') }}
          </p>
        </div>
      </template>
    </Dialog>
  </div>
</template>
